export type Mail = { body: string; subject: string };
export class MailNotifyData {
  static SUBJECT_PREFIX = '[サークルオー運営]';

  static teacherAcceptMail(user: string): Mail {
    return {
      subject: `${this.SUBJECT_PREFIX}先生申請受理のお知らせ`,
      body: `${user} 様

ろう・難聴児のオンライン対話学習コミュニティ「サークルオー」運営担当でございます。
この度は「サークルオー」の先生にお申し込みいただきありがとうございました。

厳正に選考を進め、順次ご連絡をいたします。

お待たせいたしまして申し訳ございませんが、選考結果のご連絡まで少々おまちください。


簡単ではございますが、申請受理のご連絡とさせていただきます。

引き続きサークルオーをよろしくお願いいたします。`,
    };
  }

  static teacherFailureMail(user: string): Mail {
    return {
      subject: `${this.SUBJECT_PREFIX}選考結果のお知らせ`,
      body: `${user} 様
ろう・難聴児のオンライン対話学習コミュニティ「サークルオー」運営担当でございます。
この度は「サークルオー」の先生にお申し込みいただきありがとうございました。

選考の進捗について、ご連絡させていただきます。


選考を進め、運営事務局としても選考に苦慮いたしましたが

大変心苦しく思うのですが、今回の${user}さまのご要望に至らず

「不合格」とさせていただきます。


　※また選考状況についてのお応えはできかねますこと、

　　畏れ入りますが何卒ご了承ください。


ご要望にお応えできないこと、何卒ご容赦くださいませ。


${user}さまにおかれましても健康にご留意のうえお過ごしされますこと、祈念しております。


本件ご申請にお応えできず、大変恐縮ではございますが
上記、選考進捗についてご連絡させていただきます。


以上、何卒よろしくお願いいたします。`.replace(/\n/g, '%0D%0A'),
    };
  }

  static windowTeacherInterviewAppoint(user: string): Mail {
    return {
      subject: `${this.SUBJECT_PREFIX}１次選考通過 面接日程調整のお知らせ`,
      body: `${user} 様
初めまして。
ろう・難聴児のオンライン対話学習コミュニティ「サークルオー」運営担当の◯◯と申します。
この度はお申込み頂きましてありがとうございます。

是非 ◯◯ 様とオンラインにて面接させていただきたくご連絡差し上げました。

面接日ですが、以下の候補日のいずれかでいかがでしょうか。
①◯/◯（◯）00:00~00:00
②◯/◯（◯）00:00~00:00
③◯/◯（◯）00:00~00:00

もし都合がつかないようであれば、
◯日以降でご対応できる時間帯を3つご連絡ください。

以上、
どうぞよろしくお願いいたします。
`.replace(/\n/g, '%0D%0A'),
    };
  }

  static teacherSuccessMail(user: string, mail: string, password: string, building: string) {
    return {
      subject: `${this.SUBJECT_PREFIX}選考結果のお知らせ`,
      body: `${user} 様

ろう・難聴児のオンライン対話学習コミュニティ「サークルオー」運営担当の◯◯です。
先日は面接ありがとうございました。

先日は面談のお時間をいただきありがとうございました。
${user} 様にサークルオーの先生としてご活躍いただきたいと思っております。
全国の聞こえない子供達への教育活動を一緒に広げていきましょう！

早速ではございますが、以下のURLにアクセスしてログインしてください。
URL：https://circle-o.jp/web/teacher-login-page?building=co01

ユーザーID: ${mail}
初期パスワード: ${password}

ログインしていただき、詳しい先生情報およびアピール文、
LINEの通知設定などをご登録いただきます。

ご登録が終わりましたら、運営に一報お願いいたします。

授業予約の依頼はLINEに通知されますので、
予約依頼を受け付けたらできるだけ早く対応することを心がけてください。

詳しいマニュアルは以下にございます。
https://circle-o.jp/assets/manual/

今後、ご一緒できることを心より楽しみにしております。
どうぞよろしくお願いいたします。
`.replace(/\n/g, '%0D%0A'),
    };
  }
}
